export default __webpack_public_path__ + "static/media/2、首页大无糖茶.f5b7eda2.jpg";